import React, {createContext, useCallback, useState} from "react";
import Notice from "v4/components/ui/Notice/Notice";
import {createPortal} from "react-dom";

const defaultNotifications = {
    addNotification: ({type = 'success', message, show = true, delay = null}) => {
    },
    addSuccessNotification: (message) => {
    },
    addErrorNotification: (message) => {
    },
    addInfoNotification: (message) => {
    },
}

export const NotificationContext = createContext(defaultNotifications)
export const NotificationContextExternal = {};

export default function NotificationProvider({children}) {
    const [notifications, setNotifications] = useState([])

    const addNotification = useCallback((notification) => {
        setNotifications(notifications => [...notifications, {
            type: 'success',
            message: null,
            show: true,
            delay: null,
            ...notification
        }])
    }, [])

    const addSuccessNotification = useCallback((message) => {
        setNotifications(notifications => [...notifications, {
            type: 'success',
            message: message,
            show: true
        }])
    }, [])

    const addErrorNotification = useCallback((message) => {
        setNotifications(notifications => [...notifications, {
            type: 'error',
            message: message,
            show: true
        }])
    }, [])

    const addInfoNotification = useCallback((message) => {
        setNotifications(notifications => [...notifications, {
            type: 'info',
            message: message,
            show: true
        }])
    }, [])

    const valueProvided = {
        addNotification,
        addSuccessNotification,
        addErrorNotification,
        addInfoNotification
    }

    Object.assign(NotificationContextExternal, valueProvided);

    return (
        <NotificationContext.Provider
            value={valueProvided}>
            {children}

            {createPortal(
                <div className="admin__notifications__wrapper notifications__wrapper">
                    {notifications.map((notification, index) => {
                        return <Notice key={index} {...notification}/>
                    })}
                </div>, document.body)}
        </NotificationContext.Provider>
    )
}
